(() => {
  const protectionClass = 'boxify-human-protection';
  const verifiedClass = 'boxify-human-verified';
  const verificationProperty = '_checkout_method';
  const verificationValue = 'verified_human';
  let requestInProgress = false;

  function setVerified(isVerified) {
    document.documentElement.classList.toggle(verifiedClass, isVerified);

    document.querySelectorAll('[data-boxify-human-verification]').forEach((container) => {
      const button = container.querySelector('[data-boxify-human-verify]');
      const success = container.querySelector('[data-boxify-human-success]');
      const error = container.querySelector('[data-boxify-human-error]');

      if (button) button.hidden = isVerified;
      if (success) success.hidden = !isVerified;
      if (error && isVerified) error.hidden = true;
    });
  }

  async function getCart() {
    const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  function cartIsVerified(cart) {
    return (
      cart.item_count > 0 &&
      cart.items.every((item) => item.properties?.[verificationProperty] === verificationValue)
    );
  }

  async function refreshVerificationState() {
    try {
      const cart = await getCart();
      setVerified(cartIsVerified(cart));
    } catch (error) {
      console.error('Unable to confirm cart verification state.', error);
      setVerified(false);
    }
  }

  function showVerificationError(container) {
    const error = container?.querySelector('[data-boxify-human-error]');
    if (error) error.hidden = false;
  }

  async function verifyCart(container) {
    if (requestInProgress) return;

    requestInProgress = true;
    const buttons = document.querySelectorAll('[data-boxify-human-verify]');
    buttons.forEach((button) => {
      button.disabled = true;
      button.textContent = 'Verifying…';
    });

    document.querySelectorAll('[data-boxify-human-error]').forEach((error) => {
      error.hidden = true;
    });

    try {
      const cart = await getCart();
      if (cart.item_count === 0) throw new Error('Cart is empty');

      for (const item of cart.items) {
        const response = await fetch(window.routes?.cart_change_url || '/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: item.key,
            properties: {
              ...(item.properties || {}),
              [verificationProperty]: verificationValue,
            },
          }),
        });

        if (!response.ok) throw new Error('Unable to mark cart item as verified');
        await response.json();
      }

      const verifiedCart = await getCart();
      if (!cartIsVerified(verifiedCart)) throw new Error('Cart verification was not retained');

      setVerified(true);
      document.querySelector('button[name="checkout"], input[name="checkout"]')?.focus();
    } catch (error) {
      console.error('Boxify cart verification failed.', error);
      setVerified(false);
      showVerificationError(container);
    } finally {
      requestInProgress = false;
      buttons.forEach((button) => {
        button.disabled = false;
        button.textContent = 'Verify you are human to continue';
      });
    }
  }

  document.documentElement.classList.add(protectionClass);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-boxify-human-verify]');
    if (!button) return;

    event.preventDefault();
    verifyCart(button.closest('[data-boxify-human-verification]'));
  });

  document.addEventListener(
    'submit',
    (event) => {
      if (
        !document.documentElement.classList.contains(verifiedClass) &&
        event.submitter?.matches('[name="checkout"]')
      ) {
        event.preventDefault();
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', refreshVerificationState);
  document.addEventListener('shopify:section:load', refreshVerificationState);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setVerified(false);
      window.setTimeout(refreshVerificationState, 250);
    });
  }
})();
